import { render, staticRenderFns } from "./PMN-Biobank.vue?vue&type=template&id=01eaecb4&scoped=true&"
import script from "./PMN-Biobank.vue?vue&type=script&lang=ts&"
export * from "./PMN-Biobank.vue?vue&type=script&lang=ts&"
import style0 from "./PMN-Biobank.vue?vue&type=style&index=0&id=01eaecb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eaecb4",
  null
  
)

export default component.exports